import React, { useState, useEffect, useRef } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
  Input,
  Progress,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import imgupload from "../../../assets/images/imageupload.svg";

const GymsCategoryAdd = () => {
  document.title = "Add Gym Category | Elevated - Admin Dashboard";
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    title: Yup.string()

      .max(30, "Title must not exceed 30 characters")
      .required("Title is required"),
  });

  const handleSubmit = async (values) => {
    try {
      // Use Promise.all to handle all uploads
      const resp = await post(`${endpoints.gymCategory}`, values);

      if (resp.data.success) {
        toast.success(`Category Added Successfully`, {
          position: "bottom-center",
          theme: "colored",
          transition: Bounce,
        });
        navigate(`/gym-category`);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
    }
  };
  const inputRef = useRef(null);

  return (
    <div className="mx-2">
      <Container fluid className="">
        <Row>
          <Card className="rounded-4 ">
            <Formik
              initialValues={{
                title: "",
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
              validateOnBlur={true}
            >
              {({
                errors,
                touched,
                resetForm,
                values,
                setFieldValue,
                isSubmitting,
              }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    Add New Gym Category
                  </h3>
                  <div>
                    <FormGroup className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <Field
                        style={{
                          width: "100%",
                          maxWidth: "412px",
                          height: "56px",
                          border: "none",
                        }}
                        name={`title`}
                        as={Input}
                        placeholder="Gym Category Name"
                        className={`rounded-5 bg-light custom-placeholder ff-sora font-size-16 fw-normal px-4  ${
                          errors.title && touched.title ? "is-invalid" : ""
                        }`}
                      />
                      <ErrorMessage
                        name={`title`}
                        component="div"
                        className="text-danger ff-sora font-size-12 fw-normal"
                      />
                    </FormGroup>
                  </div>
                  <div className="d-flex float-end">
                    <Button
                      type="submit"
                      className="me-2 rounded-pill"
                      disabled={isSubmitting}
                    >
                      Add Category
                    </Button>
                    <Button
                      color="white"
                      className="rounded-pill1"
                      onClick={() => {
                        resetForm();

                        navigate(`/gym-category`);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Card>
        </Row>
      </Container>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          height: "60px",
          position: "sticky",
          bottom: "0",
          zIndex: "10",
        }}
      ></div>
    </div>
  );
};

export default GymsCategoryAdd;
